import React, { useState, useEffect, useMemo } from "react";
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBDropdown,
  MDBDropdownMenu,
  MDBDropdownToggle,
  MDBDropdownItem,
  MDBTable,
  MDBTableHead,
  MDBTableBody,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
  MDBListGroup,
  MDBListGroupItem,
  MDBPagination,
  MDBPaginationItem,
  MDBPaginationLink,
  MDBInput,
  MDBAutocomplete,
  MDBIcon,
  MDBBtn,
  // MDBDatepicker, // Commented for now
} from "mdb-react-ui-kit";
import { getAccountSummarys, getMisc } from "../apiclients/streamsapi_bridge";
import { Tooltip } from "react-tooltip";
import { Totalpages, Totalvisit } from "./images";

// Generate comparison data (simulates previous period data)
// COMMENTED - Not in use currently
// const generateComparisonData = (originalData, variationPercent = 0.15) => {
//   if (!Array.isArray(originalData) || originalData.length === 0) {
//     return [];
//   }
//   return originalData.map((account) => ({
//     ...account,
//     pages: Array.isArray(account.pages)
//       ? account.pages.map((page) => ({
//           ...page,
//           visits: Math.max(
//             1,
//             Math.round(page.visits * (0.85 + Math.random() * variationPercent))
//           ),
//         }))
//       : [],
//   }));
// };

export default function Heatmap() {
  const [selectedAccount, setSelectedAccount] = useState("All Accounts");
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  // const [fromDate, setFromDate] = useState(null); // COMMENTED
  // const [toDate, setToDate] = useState(null); // COMMENTED
  const [sortBy, setSortBy] = useState("visits");
  const [sortOrder, setSortOrder] = useState("desc");
  const [searchText, setSearchText] = useState("");
  const [searchSiteName, setSearchSiteName] = useState("");
  // const [comparisonPeriod, setComparisonPeriod] = useState("none"); // COMMENTED
  // const [comparisonData, setComparisonData] = useState(null); // COMMENTED
  const [sitenames, setsitenames] = useState([]);
  const [selectedSiteid, setSelectedSiteid] = useState(0);
  const [selectedRange, setSelectedRange] = useState("past_30_days");
  // const [error, setError] = useState(""); // COMMENTED

  // COMMENTED - Comparison data generation
  // const previousWeekData = generateComparisonData(data, 0.2);
  // const previousMonthData = generateComparisonData(data, 0.3);

    const RANGE_OPTIONS = {
        past_30_days: { label: "Last 30 days", key: "past_30_days" },
        this_week: { label: "This week", key: "this_week" },
        this_month: { label: "This month", key: "this_month" },
        past_week: { label: "Last week", key: "past_week" },
        past_month: { label: "Last month", key: "past_month" },
    };

  useEffect(() => {
    getAccountSummaryData(true);
    getAccountList();
  }, []);

  const getAccountSummaryData = async (allAccount, siteid, range) => {
    try {
      const response = await getAccountSummarys(allAccount, siteid, null, range);
      if (!response.json) return;
      const tdata = await response.json();

      console.log("API Response:", tdata);
      console.log("Is array?", Array.isArray(tdata));
      
      // Handle different data structures
      // if (Array.isArray(tdata?.summary)) {
        setData(tdata?.summary ?? []);
      
      setCurrentPage(1);
    
      setTimeout(() => {
        setRotate(false);
      }, 2000);
    } catch (err) {
      console.warn("Error fetching data:", err.message);
      setData([]);
    }
  };

  const getAccountList = async () => {
    try {
      const response = await getAccountSummarys(null, null, true);
      if (!response.json) return;
      const tdata = await response.json();

      setsitenames(tdata?.opensips_account_names ?? []);
      setCurrentPage(1);
    } catch (err) {
      console.warn("Error fetching account list:", err.message);
      setsitenames([]);
    }
  };

  // Adjust rows per page based on screen height
  useEffect(() => {
    const updateRows = () => {
    //   if (window.innerHeight < 600) setRowsPerPage(8);
    //   else if (window.innerHeight < 800) setRowsPerPage(12);
    //   else if (window.innerHeight < 1000) setRowsPerPage(15);
    setRowsPerPage(15);
    };
    updateRows();
    window.addEventListener("resize", updateRows);
    return () => window.removeEventListener("resize", updateRows);
  }, []);

  // COMMENTED - Update comparison data when comparison period changes
  // useEffect(() => {
  //   if (comparisonPeriod === "none") {
  //     setComparisonData(null);
  //   } else if (comparisonPeriod === "lastWeek") {
  //     setComparisonData(previousWeekData);
  //   } else if (comparisonPeriod === "lastMonth") {
  //     setComparisonData(previousMonthData);
  //   }
  // }, [comparisonPeriod, previousWeekData, previousMonthData]);

  // COMMENTED - Fetch data from DB when date range changes
  // useEffect(() => {
  //   if (!fromDate || !toDate) {
  //     return;
  //   }
  //   const fetchData = async () => {
  //     try {
  //       const siteid = JSON.parse(
  //         sessionStorage.getItem("admin_session")
  //       ).siteid;
  //       const response = await getMisc(siteid, {
  //         misc: ["heatmap"],
  //         fromDate,
  //         toDate,
  //       });
  //       if (!response.json) return;
  //       const tdata = await response.json();
  //       setData(tdata);
  //       setCurrentPage(1);
  //     } catch (err) {
  //       console.warn("Error fetching date range data:", err.message);
  //       setData([]);
  //     }
  //   };
  //   fetchData();
  // }, [fromDate, toDate]);

  // COMMENTED - Calculate comparison metrics
  // const calculateComparison = (current, previous) => {
  //   if (!previous || previous === 0) return null;
  //   return ((current - previous) / previous) * 100;
  // };

  // COMMENTED - Get comparison data for a specific page
  // const getComparisonForPage = (pagePath) => {
  //   if (!comparisonData) return null;
  //   const currentAccountData =
  //     selectedAccount === "All Accounts"
  //       ? getAllAccountsData(data)
  //       : data.find((a) => a.name === selectedAccount)?.pages || [];
  //   const previousAccountData =
  //     selectedAccount === "All Accounts"
  //       ? getAllAccountsData(comparisonData)
  //       : comparisonData.find((a) => a.name === selectedAccount)?.pages || [];
  //   const currentPage = currentAccountData.find((p) => p.page === pagePath);
  //   const previousPage = previousAccountData.find((p) => p.page === pagePath);
  //   if (!currentPage || !previousPage) return null;
  //   return calculateComparison(currentPage.visits, previousPage.visits);
  // };

  // Flatten all accounts for "All Accounts" view
  const getAllAccountsData = (dataSource = data) => {
    // Ensure dataSource is an array
    const sourceArray = Array.isArray(dataSource) ? dataSource : [];
    
    // If data is empty, return empty array
    if (sourceArray.length === 0) {
      return [];
    }
    
    // If it's already flat data (array of {page, visits}), return it
    if (sourceArray[0]?.page !== undefined && sourceArray[0]?.visits !== undefined) {
      return sourceArray;
    }
    
    // Otherwise, flatten from account structure
    const map = {};
    sourceArray.forEach((acc) => {
      const pages = Array.isArray(acc?.pages) ? acc.pages : [];
      pages.forEach((p) => {
        if (p?.page && p?.visits !== undefined) {
          map[p.page] = (map[p.page] || 0) + p.visits;
        }
      });
    });
    
    return Object.entries(map).map(([page, visits]) => ({ page, visits }));
  };

  // Get the current data to display
  const getCurrentData = () => {
    // Ensure data is always an array
    const dataArray = Array.isArray(data) ? data : [];
    
    if (dataArray.length === 0) {
      return [];
    }
    
    // Check if data is already in the right format (flat array of {page, visits})
    if (dataArray[0]?.page !== undefined && dataArray[0]?.visits !== undefined) {
      return dataArray;
    }
    
    // Otherwise, use getAllAccountsData to flatten it
    return getAllAccountsData(dataArray);
  };

  // Search filter with safety checks
  const filteredData = getCurrentData().filter((item) =>
    item?.page?.toLowerCase().includes((searchText || '').toLowerCase())
  );

  // Sorting
  const sortedData = [...filteredData].sort((a, b) => {
    if (sortBy === "page") {
      if (sortOrder === "asc") return (a.page || '').localeCompare(b.page || '');
      else return (b.page || '').localeCompare(a.page || '');
    } else {
      if (sortOrder === "asc") return (a.visits || 0) - (b.visits || 0);
      else return (b.visits || 0) - (a.visits || 0);
    }
  });

  // Pagination
  const totalPages = Math.ceil(sortedData.length / rowsPerPage)
    // selectedAccount === "All Accounts"
    //   ? 
    //   : 1;
  const paginatedData =sortedData.slice(
          (currentPage - 1) * rowsPerPage,
          currentPage * rowsPerPage
        );

    //   const paginatedData =
    // selectedAccount === "All Accounts"
    //   ? sortedData.slice(
    //       (currentPage - 1) * rowsPerPage,
    //       currentPage * rowsPerPage
    //     )
    //   : sortedData;

  const maxVisits = sortedData.length > 0 ? Math.max(...sortedData.map((d) => d.visits || 0)) : 1;
  const topPages = getAllAccountsData()
    .sort((a, b) => (b.visits || 0) - (a.visits || 0))
    .slice(0, 5);

  const resetAll = () => {
    setSelectedAccount("All Accounts");
    // setFromDate(null); // COMMENTED
    // setToDate(null); // COMMENTED
    getAccountSummaryData(true, null, RANGE_OPTIONS[selectedRange]?.key || "");
    setCurrentPage(1);
    setSearchText("");
    setSortBy("visits");
    setSortOrder("desc");
    // setComparisonPeriod("none"); // COMMENTED
    // setComparisonData(null); // COMMENTED
    window.location.reload();
  };
  
  // Filter sitenames based on search
  const filteredSites = useMemo(() => {
    if (!searchSiteName) return sitenames;
    return sitenames.filter(acc =>
      acc.companyname.toLowerCase().includes(searchSiteName.toLowerCase())
    );
  }, [sitenames, searchSiteName]);

  const exportCSV = () => {
    // COMMENTED - Comparison logic
    // const rows =
    //   comparisonPeriod !== "none"
    //     ? [["Page", "Visits", "Change %"]]
    //     : [["Page", "Visits"]];
    
    const rows = [["Page", "Visits"]];

    sortedData.forEach((r) => {
      // COMMENTED - Comparison logic
      // const comparison = getComparisonForPage(r.page);
      // if (comparisonPeriod !== "none" && comparison !== null) {
      //   rows.push([r.page, r.visits, `${comparison.toFixed(1)}%`]);
      // } else {
      //   rows.push([r.page, r.visits]);
      // }
      rows.push([r.page, r.visits]);
    });

    const csvContent =
      "data:text/csv;charset=utf-8," + rows.map((e) => e.join(",")).join("\n");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `${selectedAccount}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // COMMENTED - Date validation
  // const today = new Date();
  // const oneYearAgo = new Date();
  // oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);

  // const handleFromDateChange = (val) => {
  //   const selected = new Date(val.value);
  //   if (selected > today) {
  //     setError("From date cannot be in the future");
  //     return;
  //   }
  //   if (toDate && selected > new Date(toDate)) {
  //     setError("From date cannot be after To date");
  //     return;
  //   }
  //   setError("");
  //   setFromDate(val.value);
  // };

  // const handleToDateChange = (val) => {
  //   const selected = new Date(val.value);
  //   if (selected > today) {
  //     setError("To date cannot be in the future");
  //     return;
  //   }
  //   if (fromDate && selected < new Date(fromDate)) {
  //     setError("To date cannot be before From date");
  //     return;
  //   }
  //   setError("");
  //   setToDate(val.value);
  // };

  // COMMENTED - Calculate comparison KPIs
  // const getComparisonKPIs = () => {
  //   if (!comparisonData) return null;
  //   const currentTotal = sortedData.reduce((s, r) => s + r.visits, 0);
  //   const previousData =
  //     selectedAccount === "All Accounts"
  //       ? getAllAccountsData(comparisonData)
  //       : comparisonData.find((a) => a.name === selectedAccount)?.pages || [];
  //   const previousTotal = previousData.reduce((s, r) => s + r.visits, 0);
  //   const totalChange = calculateComparison(currentTotal, previousTotal);
  //   const avgChange = sortedData.length
  //     ? calculateComparison(
  //         currentTotal / sortedData.length,
  //         previousTotal / previousData.length
  //       )
  //     : null;
  //   return {
  //     totalChange,
  //     avgChange,
  //     previousTotal,
  //   };
  // };

  // const comparisonKPIs = getComparisonKPIs();

  // COMMENTED - Prepare chart data for comparison
  // const getChartData = () => {
  //   if (comparisonPeriod === "none" || !comparisonData) return [];
  //   const currentData =
  //     selectedAccount === "All Accounts"
  //       ? getAllAccountsData(data)
  //       : data.find((a) => a.name === selectedAccount)?.pages || [];
  //   const previousData =
  //     selectedAccount === "All Accounts"
  //       ? getAllAccountsData(comparisonData)
  //       : comparisonData.find((a) => a.name === selectedAccount)?.pages || [];
  //   const topCurrentPages = currentData
  //     .sort((a, b) => b.visits - a.visits)
  //     .slice(0, 10);
  //   return topCurrentPages.map((currentPage) => {
  //     const previousPage = previousData.find(
  //       (p) => p.page === currentPage.page
  //     );
  //     return {
  //       page:
  //         currentPage.page.length > 20
  //           ? currentPage.page.substring(0, 20) + "..."
  //           : currentPage.page,
  //       fullPage: currentPage.page,
  //       current: currentPage.visits,
  //       previous: previousPage ? previousPage.visits : 0,
  //     };
  //   });
  // };

  // const chartData = getChartData();
  // const maxValue = Math.max(
  //   ...chartData.flatMap((d) => [d.current, d.previous])
  // );

  const [rotate, setRotate] = useState(false);

    return (
        <MDBContainer className="py-4 vp-surface d-flex flex-column h-100">
            {/* Page header + actions */}
            <div style={{ paddingBottom: '30px' }}>
                <MDBRow className="gy-3 mb-3 align-items-center">
                    <MDBCol lg="6">
                        <div className="d-flex     align-items-center">
                            <h3 className="fw-semibold mb-0 pe-2">Visited Pages</h3>
                            <p className="mb-0 ps-2 pt-1 square border-start border-2 border-muted">{selectedAccount}</p>
                        </div>
                        <p className="text-muted small mb-0">
                            Traffic heatmap, top pages, and quick insights.
                        </p>
                    </MDBCol>
                    <MDBCol lg="6">
                        <div className="d-flex justify-content-lg-end gap-2">
                            {/* COMMENTED - Date pickers */}
                            {/* <div>
              <MDBDatepicker
                inline
                className="rounded-pill border pe-2"
                toggleButton={false}
                getValue={handleFromDateChange}
                maxDate={today}
                minDate={oneYearAgo}
                value={fromDate || ""}
              />
              {error && fromDate && error.includes("From") && (
                <div className="text-danger small mt-1">{error}</div>
              )}
            </div>

            <div>
              <MDBDatepicker
                inline
                className="rounded-pill border pe-2"
                toggleButton={false}
                getValue={handleToDateChange}
                maxDate={today}
                minDate={oneYearAgo}
                value={toDate || ""}
              />
              {error && toDate && error.includes("To") && (
                <div className="text-danger small mt-1">{error}</div>
              )}
            </div> */}

                            {/* COMMENTED - Comparison dropdown */}
                            {/* <MDBDropdown>
              <MDBDropdownToggle
                color="light"
                className="rounded-pill border-0 d-flex align-items-center px-4 fw-semibold"
                style={{
                  background:
                    "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
                  color: "white",
                  boxShadow: "0 4px 12px rgba(79, 172, 254, 0.3)",
                  transition: "all 0.3s ease",
                }}
              >
                {comparisonPeriod === "none"
                  ? "Compare with"
                  : comparisonPeriod === "lastWeek"
                  ? "vs Last Week"
                  : "vs Last Month"}
              </MDBDropdownToggle>
              <MDBDropdownMenu>
                <MDBDropdownItem
                  link
                  onClick={() => setComparisonPeriod("none")}
                  className={comparisonPeriod === "none" ? "active" : ""}
                >
                  No Comparison
                </MDBDropdownItem>
                <MDBDropdownItem
                  link
                  onClick={() => setComparisonPeriod("lastWeek")}
                  className={comparisonPeriod === "lastWeek" ? "active" : ""}
                >
                  Compare with Last Week
                </MDBDropdownItem>
                <MDBDropdownItem
                  link
                  onClick={() => setComparisonPeriod("lastMonth")}
                  className={comparisonPeriod === "lastMonth" ? "active" : ""}
                >
                  Compare with Last Month
                </MDBDropdownItem>
              </MDBDropdownMenu>
            </MDBDropdown> */}
                            {/* 
                      <MDBBtn className='mx-2 w-20' tag='a' color='dark' outline floating>
                         <MDBIcon fas icon="sync-alt" size="5x" />
                      </MDBBtn> */}
                            <div className="ref-btn">
                                <MDBIcon
                                    fas
                                    icon="redo-alt"
                                    size="lg"
                                    className={`cursor-pointer refreshtip me-2 ${rotate ? "rotate-infinite" : ""}`}
                                    onClick={() => {
                                        setRotate(true);
                                        if(selectedAccount === "All Accounts"){
                                            getAccountSummaryData(true, null, RANGE_OPTIONS[selectedRange]?.key || "");    
                                        } else {
                                            getAccountSummaryData(null, selectedSiteid, RANGE_OPTIONS[selectedRange]?.key || "");
                                        }
                                    }}   // toggle start/stop
                                />
                            </div>
                            <Tooltip anchorSelect=".refreshtip" place="bottom" className="exampleTooltip">
                                Refresh
                            </Tooltip>

                            <MDBDropdown>
                                <MDBDropdownToggle
                                    color="light"
                                    className="rounded-pill border-0 d-flex align-items-center px-4 fw-semibold justify-content-between account-dropbtn"
                                    style={{
                                        background:
                                            "linear-gradient(135deg, #0b5a89 0%, #2894d3 100%)",
                                        color: "white",
                                        boxShadow: "0 4px 12px rgba(67, 233, 123, 0.3)",
                                        transition: "all 0.3s ease",
                                    }}
                                >
                                    {RANGE_OPTIONS[selectedRange]?.label || ""}
                                </MDBDropdownToggle>
                                <MDBDropdownMenu className="bg-white square border allacount-dropdown">
                                    <MDBDropdownItem className="bg-white" link
                                        onClick={() => {
                                            if (selectedAccount === "All Accounts") {
                                                getAccountSummaryData(true, null, "past_30_days");
                                            } else {
                                                getAccountSummaryData(null, selectedSiteid, "past_30_days");
                                            }
                                            setSelectedRange("past_30_days");
                                        }}
                                    >
                                        Last 30 days
                                    </MDBDropdownItem>
                                    <MDBDropdownItem className="bg-white" link
                                        onClick={() => {
                                            if (selectedAccount === "All Accounts") {
                                                getAccountSummaryData(true, null, 'this_week');
                                            } else {
                                                getAccountSummaryData(null, selectedSiteid, 'this_week');
                                            }
                                            setSelectedRange("this_week");
                                        }}
                                    >
                                        This week
                                    </MDBDropdownItem>
                                    <MDBDropdownItem className="bg-white" link
                                        onClick={() => {
                                            if (selectedAccount === "All Accounts") {
                                                getAccountSummaryData(true, null, 'this_month');
                                            } else {
                                                getAccountSummaryData(null, selectedSiteid, 'this_month');
                                            }
                                            setSelectedRange("this_month");
                                        }}
                                    >
                                        This month
                                    </MDBDropdownItem>
                                    <MDBDropdownItem className="bg-white" link
                                        onClick={() => {
                                            if (selectedAccount === "All Accounts") {
                                                getAccountSummaryData(true, null, 'past_week');
                                            } else {
                                                getAccountSummaryData(null, selectedSiteid, 'past_week');
                                            }
                                            setSelectedRange("past_week");
                                        }}
                                    >
                                        Last week
                                    </MDBDropdownItem>
                                    <MDBDropdownItem className="bg-white" link
                                        onClick={() => {
                                            if (selectedAccount === "All Accounts") {
                                                getAccountSummaryData(true, null, 'past_month');
                                            } else {
                                                getAccountSummaryData(null, selectedSiteid, 'past_month');
                                            }
                                            setSelectedRange("past_month");
                                        }}
                                    >
                                        Last month
                                    </MDBDropdownItem>

                                </MDBDropdownMenu>
                            </MDBDropdown>


                            <MDBDropdown>
                                <MDBDropdownToggle
                                    color="light"
                                    className="rounded-pill border-0 d-flex align-items-center px-4 fw-semibold justify-content-between text-white account-dropbtn"
                                    style={{
                                        background:
                                            "linear-gradient(135deg, #0b5a89 0%, #2894d3 100%)",
                                        boxShadow: "0 4px 12px rgba(67, 233, 123, 0.3)",
                                        transition: "all 0.3s ease",
                                        minWidth: '200px',
                                    }}
                                >
                                    <span className="text-truncate fw-semibold text-white" style={{ maxWidth: 150, fontSize: '13px', textTransform: 'none' }}> {selectedAccount}</span>
                                </MDBDropdownToggle>
                                <MDBDropdownMenu className="bg-white square border allacount-dropdown">
                                    <div>
                                        <div className='mt-0 p position-relative w-auto p-2 pt-3'>
                                            <MDBInput
                                                label="Search"
                                                value={searchSiteName}
                                                onChange={(e) => setSearchSiteName(e.target.value)}
                                            />
                                            <MDBIcon fas icon="search" className='MDBDatatable-Search' />
                                        </div>
                                        <span onClick={resetAll} className=" text-end d-block pb-1 pe-2 cursor-pointer account-link"> All Accounts</span>
                                    </div>
                                    <div className="allaccount-list">
                                        {/* {sitenames.map((acc) => (
                  <MDBDropdownItem className="bg-white"
                    link
                    key={acc.companyname}
                    onClick={() => {
                      setSelectedAccount(acc.companyname);
                      setCurrentPage(1);
                      getAccountSummaryData(null, acc.siteid);
                    }}
                  >
                    {acc.companyname}
                  </MDBDropdownItem>
                ))} */}
                                        {filteredSites.length > 0 ? (
                                            filteredSites.map((acc) => (
                                                <MDBDropdownItem
                                                    className="bg-white"
                                                    link
                                                    key={acc.siteid}
                                                    onClick={() => {
                                                        setSelectedAccount(acc.companyname);
                                                        setCurrentPage(1);
                                                        setSelectedSiteid(acc.siteid);
                                                        getAccountSummaryData(null, acc.siteid, RANGE_OPTIONS[selectedRange]?.key || "");
                                                        setSearchSiteName("");
                                                    }}
                                                >
                                                    {acc.companyname}
                                                </MDBDropdownItem>
                                            ))
                                        ) : (
                                            <div className="text-muted text-center py-2">No matching results found</div>
                                        )}
                                    </div>
                                </MDBDropdownMenu>
                            </MDBDropdown>

                            <button
                                type="button"
                                className="btn rounded-pill d-flex align-items-center px-4 fw-semibold border-0 text-dark"
                                style={{
                                    background: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
                                    color: "white",
                                    boxShadow: "0 4px 12px rgba(250, 112, 154, 0.3)",
                                    transition: "all 0.3s ease",
                                }}
                                onClick={exportCSV}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = "translateY(-2px)";
                                    e.currentTarget.style.boxShadow =
                                        "0 6px 20px rgba(250, 112, 154, 0.4)";
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = "translateY(0)";
                                    e.currentTarget.style.boxShadow =
                                        "0 4px 12px rgba(250, 112, 154, 0.3)";
                                }}
                            >
                                Export CSV
                            </button>
                        </div>
                    </MDBCol>
                </MDBRow>

                {/* KPIs */}
                {(() => {
                    const total = sortedData.reduce((s, r) => s + (r.visits || 0), 0);
                    const avg = sortedData.length
                        ? Math.round(total / sortedData.length)
                        : 0;
                    const top = sortedData[0];

                    return (
                        <MDBRow className="gy-3 mb-4">
                            <MDBCol md="6">
                                <MDBCard className="kpi-card shadow-0 border rounded-4 h-100">
                                    <MDBCardBody>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <div className="me-3">
                                                    <p className="text-muted text-uppercase small mb-1">
                                                        Total Visits
                                                    </p>
                                                    <div className="display-6 fw-semibold d-flex align-items-center gap-2">
                                                        {total.toLocaleString()}
                                                        {/* COMMENTED - Comparison badge */}
                                                        {/* {comparisonKPIs && comparisonKPIs.totalChange !== null && (
                                                 <span
                                                   className={`badge ${
                                                     comparisonKPIs.totalChange >= 0
                                                       ? "bg-success-subtle text-success-emphasis"
                                                       : "bg-danger-subtle text-danger-emphasis"
                                                   }`}
                                                 >
                                                   {comparisonKPIs.totalChange >= 0 ? "+" : ""}
                                                   {comparisonKPIs.totalChange.toFixed(1)}%
                                                 </span>
                                               )} */}
                                                    </div>
                                                    <div className="text-muted small">
                                                        Across {sortedData.length} pages
                                                        {/* COMMENTED - Previous total */}
                                                        {/* {comparisonKPIs && (
                                                 <span className="ms-2">
                                                   (was {comparisonKPIs.previousTotal.toLocaleString()})
                                                 </span>
                                               )} */}
                                                    </div>
                                                </div>
                                            </div>
                                           
                                            <div className="visti-rightcol">
                                                <img src={Totalvisit} alt="" />
                                            </div>
                                        </div>
                                    </MDBCardBody>
                                </MDBCard>
                            </MDBCol>
                            <MDBCol md="6">
                                <MDBCard className="kpi-card shadow-0 border rounded-4 h-100">
                                    <MDBCardBody>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <p className="text-muted text-uppercase small mb-1">
                                                    Top Page
                                                </p>
                                                <div className="display-6 fw-semibold mb-0 d-flex align-items-center gap-2">
                                                    {top ? top.page : "—"}
                                                    {/* COMMENTED - Comparison for top page */}
                                                    {/* {top &&
                                                 comparisonPeriod !== "none" &&
                                                 (() => {
                                                   const comparison = getComparisonForPage(top.page);
                                                   return (
                                                     comparison !== null && (
                                                       <span
                                                         className={`badge ${
                                                           comparison >= 0
                                                             ? "bg-success-subtle text-success-emphasis"
                                                             : "bg-danger-subtle text-danger-emphasis"
                                                         }`}
                                                       >
                                                         {comparison >= 0 ? "+" : ""}
                                                         {comparison.toFixed(1)}%
                                                       </span>
                                                     )
                                                   );
                                                 })()} */}
                                                </div>
                                                <div className="text-muted small">
                                                    {top ? top.visits.toLocaleString() : 0} visits
                                                </div>
                                            </div>

                                         

                                            <div className="visti-rightcol">
                                                <img src={Totalpages} alt="" />
                                            </div>
                                        </div>
                                    </MDBCardBody>
                                </MDBCard>
                            </MDBCol>
                            {/* <MDBCol md="4">
                                <MDBCard className="kpi-card shadow-0 border rounded-4 h-100">
                <MDBCardBody>
                  <p className="text-muted text-uppercase small mb-1">
                    Avg per Page
                  </p>
                  <div className="display-6 fw-semibold d-flex align-items-center gap-2">
                    {avg.toLocaleString()} */}
                                {/* COMMENTED - Comparison for average */}
                                {/* {comparisonKPIs && comparisonKPIs.avgChange !== null && (
                      <span
                        className={`badge ${
                          comparisonKPIs.avgChange >= 0
                            ? "bg-success-subtle text-success-emphasis"
                            : "bg-danger-subtle text-danger-emphasis"
                        }`}
                      >
                        {comparisonKPIs.avgChange >= 0 ? "+" : ""}
                        {comparisonKPIs.avgChange.toFixed(1)}%
                      </span>
                    )} */}
                                {/* </div>
                  <div className="text-muted small">
                    Mean visits across filtered pages
                  </div>
                </MDBCardBody>
              </MDBCard>
                            </MDBCol> */}
                        </MDBRow>
                    );
                })()}
            </div>
           
            <MDBRow className="gy-4 pb-2" style={{ overflow: "auto", height: "calc(100vh - 263px)" }}>
                {/* COMMENTED - Comparison Chart */}
                {/* {comparisonPeriod !== "none" && (
          <MDBCol xs="12">
            <MDBCard className="shadow-2-strong border-0 rounded-4 mb-4">
              ... Chart content ...
            </MDBCard>
          </MDBCol>
        )} */}

                {/* Left: Heatmap table */}
                <MDBCol xl="8" className="mt-2">
                    <MDBCard className="shadow-2-strong border-0 rounded-4 h-100">
                        <MDBCardHeader className="bg-white border-0 pb-0">
                            <h6 className="mb-2" style={{ fontSize: '15px' }}>
                                Visited Pages Heatmap
                                {/* COMMENTED - Comparison period text */}
                                {/* {comparisonPeriod !== "none" && (
                  <span className="text-muted ms-2">
                    (vs{" "}
                    {comparisonPeriod === "lastWeek"
                      ? "Last Week"
                      : "Last Month"}
                    )
                  </span>
                )} */}
                            </h6>
                        </MDBCardHeader>

                        <MDBCardBody className="pt-2 h-100 d-flex flex-column">
                            <div className="d-flex justify-content-between align-items-center gap-2 mb-2">
                                <MDBInput
                                    className="w-40"
                                    placeholder="Search names (e.g. Home)"
                                    type="text"
                                    value={searchText}
                                    onChange={(e) => setSearchText(e.target.value)}
                                    style={{
                                        background:
                                            "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)",
                                        border: "none",
                                        color: "#2d3436",
                                        borderRadius: "25px",
                                        fontWeight: "500",
                                    }}
                                />
                                {/* <button
                                    type="button"
                                    className="btn rounded-pill filt-dtn fw-semibold border-0"
                                    style={{
                                        background:
                                            "linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)",
                                        color: "#2d3436",
                                        boxShadow: "0 4px 12px rgba(252, 182, 159, 0.3)",
                                        transition: "all 0.3s ease",
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = "translateY(-2px)";
                                        e.currentTarget.style.boxShadow =
                                            "0 6px 20px rgba(252, 182, 159, 0.4)";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = "translateY(0)";
                                        e.currentTarget.style.boxShadow =
                                            "0 4px 12px rgba(252, 182, 159, 0.3)";
                                    }}
                                >
                                    <i className="bi bi-funnel me-1" /> Filters
                                </button> */}
                            </div>

                            <div className="table-responsive heatmap-table-wrap rounded-4 heatmap-table">
                                <MDBTable
                                    striped
                                    hover
                                    className="align-middle mb-0 heatmap-table"
                                    style={{
                                        background:
                                            "linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)",
                                        borderRadius: "16px",
                                        overflow: "hidden",
                                    }}
                                >
                                    <MDBTableHead
                                        style={{
                                            background:
                                                "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                            color: "white",
                                        }}
                                    >
                                        <tr>
                                            <th
                                                className=" fw-bold cursor-pointer px-4 py-4"
                                                style={{
                                                    borderBottom: "none",
                                                }}
                                                onClick={() => {
                                                    setSortBy("page");
                                                    setSortOrder(
                                                        sortBy === "page" && sortOrder === "asc"
                                                            ? "desc"
                                                            : "asc"
                                                    );
                                                }}
                                            >
                                                Page
                                                <span
                                                    className="badge ms-2 fw-semibold"
                                                    style={{
                                                        background: "rgba(255,255,255,0.2)",
                                                        color: "white",
                                                        border: "1px solid rgba(255,255,255,0.3)",
                                                    }}
                                                >
                                                    {sortBy === "page" ? sortOrder : "sort"}
                                                </span>
                                            </th>
                                            <th
                                                className=" fw-bold text-end cursor-pointer px-4 py-4"
                                                style={{
                                                    borderBottom: "none",
                                                }}
                                                onClick={() => {
                                                    setSortBy("visits");
                                                    setSortOrder(
                                                        sortBy === "visits" && sortOrder === "asc"
                                                            ? "desc"
                                                            : "asc"
                                                    );
                                                }}
                                            >
                                                Visits
                                                <span
                                                    className="badge ms-2 fw-semibold"
                                                    style={{
                                                        background: "rgba(255,255,255,0.2)",
                                                        color: "white",
                                                        border: "1px solid rgba(255,255,255,0.3)",
                                                    }}
                                                >
                                                    {sortBy === "visits" ? sortOrder : "sort"}
                                                </span>
                                            </th>
                                            {/* COMMENTED - Change column */}
                                            {/* {comparisonPeriod !== "none" && (
                        <th
                          className="text-uppercase small fw-bold text-center px-4 py-3"
                          style={{
                            color: "white",
                            borderBottom: "none",
                          }}
                        >
                          Change
                        </th>
                      )} */}
                                        </tr>
                                    </MDBTableHead>

                                    <MDBTableBody>
                                        {paginatedData?.length == 0 &&
                                            <tr>
                                                <td colSpan="100%" className="text-muted text-center py-3">
                                                    No matching results found
                                                </td>
                                            </tr>
                                        }
                                        {paginatedData.map((item, idx) => {
                                            // COMMENTED - Comparison logic
                                            // const comparison =
                                            //   comparisonPeriod !== "none"
                                            //     ? getComparisonForPage(item.page)
                                            //     : null;
                                            const rowColors = [
                                                "linear-gradient(135deg, #fff5f5 0%, #fed7d7 50%, #ffffff 100%)",
                                                "linear-gradient(135deg, #f0fff4 0%, #c6f6d5 50%, #ffffff 100%)",
                                                "linear-gradient(135deg, #f7fafc 0%, #edf2f7 50%, #ffffff 100%)",
                                                "linear-gradient(135deg, #fffaf0 0%, #feebc8 50%, #ffffff 100%)",
                                                "linear-gradient(135deg, #faf5ff 0%, #e9d8fd 50%, #ffffff 100%)",
                                            ];

                                            return (
                                                <tr
                                                    key={idx}
                                                    className="row-hover"
                                                    style={{
                                                        background:
                                                            idx % 2 === 0
                                                                ? rowColors[idx % rowColors.length]
                                                                : "rgba(255,255,255,0.8)",
                                                        borderLeft: `4px solid ${[
                                                            "#fc8181",
                                                            "#68d391",
                                                            "#63b3ed",
                                                            "#f6ad55",
                                                            "#b794f6",
                                                        ][idx % 5]
                                                            }`,
                                                        transition: "all 0.3s ease",
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.transform = "translateX(4px)";
                                                        e.currentTarget.style.boxShadow =
                                                            "0 4px 12px rgba(0,0,0,0.1)";
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.transform = "translateX(0)";
                                                        e.currentTarget.style.boxShadow = "none";
                                                    }}
                                                >
                                                    <td className="fw-medium px-4 py-4">
                                                        <span className="me-2">{item.page}</span>
                                                        {item.page === "/home" && (
                                                            <span
                                                                className="badge fw-semibold"
                                                                style={{
                                                                    background:
                                                                        "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                                                                    color: "white",
                                                                }}
                                                            >
                                                                Top
                                                            </span>
                                                        )}
                                                    </td>
                                                    <td className="text-end px-4 py-4">
                                                        <div className="visit-chip">
                                                            <span
                                                                className="visit-heat"
                                                                style={{
                                                                    width: `${Math.max(
                                                                        8,
                                                                        ((item.visits || 0) / maxVisits) * 100
                                                                    )}%`,
                                                                    background: `linear-gradient(135deg, ${[
                                                                        "#667eea",
                                                                        "#f093fb",
                                                                        "#4facfe",
                                                                        "#43e97b",
                                                                        "#fa709a",
                                                                    ][idx % 5]
                                                                        } 0%, ${[
                                                                            "#764ba2",
                                                                            "#f5576c",
                                                                            "#00f2fe",
                                                                            "#38f9d7",
                                                                            "#fee140",
                                                                        ][idx % 5]
                                                                        } 100%)`,
                                                                    borderRadius: "4px",
                                                                    boxShadow: `0 2px 8px ${[
                                                                        "#667eea",
                                                                        "#f093fb",
                                                                        "#4facfe",
                                                                        "#43e97b",
                                                                        "#fa709a",
                                                                    ][idx % 5]
                                                                        }33`,
                                                                }}
                                                            />
                                                            <span className="visit-count fw-semibold">
                                                                {(item.visits || 0).toLocaleString()}
                                                            </span>
                                                        </div>
                                                    </td>
                                                    {/* COMMENTED - Change column */}
                                                    {/* {comparisonPeriod !== "none" && (
                            <td className="text-center px-4 py-3">
                              {comparison !== null ? (
                                <span
                                  className={`badge fw-semibold`}
                                  style={{
                                    background:
                                      comparison >= 0
                                        ? "linear-gradient(135deg, #48bb78 0%, #38a169 100%)"
                                        : "linear-gradient(135deg, #f56565 0%, #e53e3e 100%)",
                                    color: "white",
                                    boxShadow: `0 2px 8px ${
                                      comparison >= 0 ? "#48bb78" : "#f56565"
                                    }33`,
                                  }}
                                >
                                  {comparison >= 0 ? "+" : ""}
                                  {comparison.toFixed(1)}%
                                </span>
                              ) : (
                                <span className="text-muted">—</span>
                              )}
                            </td>
                          )} */}
                                                </tr>
                                            );
                                        })}
                                       
                                    </MDBTableBody>
                                </MDBTable>

                            </div>

                            {/* Pagination */}
                            {totalPages > 1 && (
                                <div className="d-flex justify-content-between align-items-center pt-3">
                                    <small className="text-muted">
                                        Showing {(currentPage - 1) * rowsPerPage + 1}–
                                        {Math.min(currentPage * rowsPerPage, sortedData.length)} of{" "}
                                        {sortedData.length}
                                    </small>

                                    <MDBPagination className="mb-0 pagination-pills">
                                        <MDBPaginationItem disabled={currentPage === 1}>
                                            <MDBPaginationLink
                                                href="#"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setCurrentPage(currentPage - 1);
                                                }}
                                            >
                                                Prev
                                            </MDBPaginationLink>
                                        </MDBPaginationItem>

                                        {[...Array(totalPages)].map((_, i) => (
                                            <MDBPaginationItem active={i + 1 === currentPage} key={i}>
                                                <MDBPaginationLink
                                                    href="#"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        setCurrentPage(i + 1);
                                                    }}
                                                >
                                                    {i + 1}
                                                </MDBPaginationLink>
                                            </MDBPaginationItem>
                                        ))}

                                        <MDBPaginationItem disabled={currentPage === totalPages}>
                                            <MDBPaginationLink
                                                href="#"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setCurrentPage(currentPage + 1);
                                                }}
                                            >
                                                Next
                                            </MDBPaginationLink>
                                        </MDBPaginationItem>
                                    </MDBPagination>
                                </div>
                            )}
                        </MDBCardBody>
                    </MDBCard>
                </MDBCol>

                {/* Right rail: Top 5 + Insights */}
                <MDBCol xl="4" className="mt-2">
                    {/* Top 5 Visited Pages */}
                    <MDBCard className="shadow-2-strong border-0 rounded-4 mb-4 pb-3">
                        <MDBCardHeader className="bg-white border-0 pb-0">
                            <h6 className="mb-2" style={{ fontSize: '15px' }}>Top 5 Visited Pages</h6>
                        </MDBCardHeader>

                        <MDBCardBody className="pt-2">
                            <MDBListGroup flush className="rounded-4">
                                {topPages.map((p, i) => {
                                    // COMMENTED - Comparison logic
                                    // const comparison =
                                    //   comparisonPeriod !== "none"
                                    //     ? getComparisonForPage(p.page)
                                    //     : null;
                                    const colors = [
                                        { bg: "#e3f2fd", border: "#2196f3", text: "#1565c0" },
                                        { bg: "#f3e5f5", border: "#9c27b0", text: "#7b1fa2" },
                                        { bg: "#e8f5e8", border: "#4caf50", text: "#388e3c" },
                                        { bg: "#fff3e0", border: "#ff9800", text: "#f57c00" },
                                        { bg: "#fce4ec", border: "#e91e63", text: "#c2185b" },
                                    ];
                                    const color = colors[i];

                                    return (
                                        <MDBListGroupItem
                                            key={i}
                                            className="d-flex justify-content-between align-items-center px-3 py-3 top5-item"
                                            style={{
                                                backgroundColor: color.bg,
                                                borderLeft: `4px solid ${color.border}`,
                                                marginBottom: i < topPages.length - 1 ? "8px" : "0",
                                                borderRadius: "8px",
                                            }}
                                        >
                                            <div className="d-flex align-items-center gap-3 min-w-0">
                                                <span
                                                    className="rank-chip d-flex align-items-center justify-content-center fw-bold"
                                                    style={{
                                                        backgroundColor: color.border,
                                                        color: "white",
                                                        width: "28px",
                                                        height: "28px",
                                                        borderRadius: "50%",
                                                        fontSize: "12px",
                                                    }}
                                                >
                                                    {i + 1}
                                                </span>
                                                <div className="d-flex flex-column min-w-0">
                                                    <span
                                                        className="fw-medium text-truncate"
                                                        style={{ color: color.text }}
                                                    >
                                                        {p.page}
                                                    </span>
                                                    {/* COMMENTED - Comparison badge */}
                                                    {/* {comparison !== null && (
                            <span
                              className={`badge badge-sm mt-1 align-self-start ${
                                comparison >= 0
                                  ? "bg-success-subtle text-success-emphasis"
                                  : "bg-danger-subtle text-danger-emphasis"
                              }`}
                            >
                              {comparison >= 0 ? "+" : ""}
                              {comparison.toFixed(0)}%
                            </span>
                          )} */}
                                                </div>
                                            </div>
                                            <div className="d-flex flex-column align-items-end">
                                                <strong style={{ color: color.text, fontSize: "16px" }}>
                                                    {(p.visits || 0).toLocaleString()}
                                                </strong>
                                                <small className="text-muted">visits</small>
                                            </div>
                                        </MDBListGroupItem>
                                    );
                                })}
                            </MDBListGroup>
                        </MDBCardBody>
                    </MDBCard>

                    {/* Mini bars */}
                    <MDBCard className="shadow-2-strong border-0 rounded-4 mb-4 pb-3 minbar-container" >
                        <MDBCardHeader className="bg-white border-0 pb-0">
                            <h6 className="mb-5" style={{ fontSize: '15px' }}>Traffic Distribution</h6>
                        </MDBCardHeader>

                        <MDBCardBody className="pt-2">
                            <div className="mini-bars mt-5">
                                {topPages.map((p, i) => {
                                    const ratio = maxVisits ? (p.visits || 0) / maxVisits : 0;
                                    const percent = Math.max(
                                        15,
                                        Math.min(100, Math.round(ratio * 100))
                                    );
                                    const colors = [
                                        "#2196f3",
                                        "#9c27b0",
                                        "#4caf50",
                                        "#ff9800",
                                        "#e91e63",
                                    ];
                                    return (
                                        <div key={i} className="mini-item">
                                            <div className="mini-bar-box">
                                                <span
                                                    className="mini-bar position-relative"
                                                    style={{
                                                        height: `${percent}%`,
                                                        backgroundColor: colors[i],
                                                        boxShadow: `0 2px 4px ${colors[i]}33`,
                                                    }}
                                                    title={`${p.page}`}
                                                >
                                                      <p className="trafic-count">{`${(p.visits || 0).toLocaleString()}`}</p>
                                                </span>
                                            </div>
                                            <small
                                                className="mini-label text-truncate"
                                                title={p.page}
                                                style={{ color: colors[i], fontWeight: "500" }}
                                            >
                                                {p.page}
                                            </small>
                                        </div>
                                    );
                                })}
                            </div>
                        </MDBCardBody>
                    </MDBCard>

                    {/* Insights */}
                    <MDBCard className="shadow-2-strong border-0 rounded-4">
                        <MDBCardHeader className="bg-white border-0 pb-0">
                            <h6 className="mb-2">Insights</h6>
                        </MDBCardHeader>
                        <MDBCardBody className="pt-2">
                            <div className="d-flex align-items-start gap-2 mb-2">
                                <span
                                    className="badge bg-light text-dark d-inline-block"
                                    style={{ width: "80px" }}
                                >
                                    Tip
                                </span>
                                <small className="text-muted">
                                    Use the search to quickly filter paths. Export a CSV for
                                    deeper analysis in your BI tool.
                                </small>
                            </div>
                            <div className="d-flex align-items-start gap-2 mb-2">
                                <span
                                    className="badge bg-light text-dark d-inline-block"
                                    style={{ width: "80px" }}
                                >
                                    Trend
                                </span>
                                <small className="text-muted">
                                    Home page remains the most visited across all accounts.
                                    Consider prioritizing updates here.
                                </small>
                            </div>
                            {/* COMMENTED - Comparison insights */}
                            {/* {comparisonPeriod !== "none" && comparisonKPIs && (
                <div className="d-flex align-items-start gap-2">
                  <span
                    className="badge bg-light text-dark d-inline-block"
                    style={{ width: "80px" }}
                  >
                    Compare
                  </span>
                  <small className="text-muted">
                    {comparisonKPIs.totalChange >= 0
                      ? "Traffic is up"
                      : "Traffic is down"}{" "}
                    {Math.abs(comparisonKPIs.totalChange).toFixed(1)}% compared
                    to{" "}
                    {comparisonPeriod === "lastWeek"
                      ? "last week"
                      : "last month"}
                    .
                  </small>
                </div>
              )} */}
                        </MDBCardBody>
                    </MDBCard>
                </MDBCol>
            </MDBRow>
          
        </MDBContainer>
    );
}